'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _covutils = require('covutils');

Object.defineProperty(exports, 'DOMAIN', {
  enumerable: true,
  get: function get() {
    return _covutils.DOMAIN;
  }
});
Object.defineProperty(exports, 'COVERAGE', {
  enumerable: true,
  get: function get() {
    return _covutils.COVERAGE;
  }
});
Object.defineProperty(exports, 'COVERAGECOLLECTION', {
  enumerable: true,
  get: function get() {
    return _covutils.COVERAGECOLLECTION;
  }
});
var LINKRELPREFIX = exports.LINKRELPREFIX = 'http://www.iana.org/assignments/relation/';